import React, { useEffect } from "react";
import { ShieldCheck, Zap, Layers, Ruler, RefreshCw } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { PageHeader } from "@/components/PageParts";
import { Card } from "@/components/ui";

const STEPS = [
  { icon: Ruler, ar_t: "1 · إدخال المعطيات", en_t: "1 · Inputs", ar_b: "أبعاد الأرض، نوع المبنى، عدد الغرف والمرافق والارتدادات.", en_b: "Land dimensions, building type, rooms, amenities and setbacks." },
  { icon: Zap, ar_t: "2 · التوليد البارامتري", en_t: "2 · Parametric generation", ar_b: "محرك قواعد هندسية (لا ذكاء اصطناعي) يبني الجدران والغرف والأعمدة بدقة المليمتر.", en_b: "A rules-based engine (no AI) builds walls, rooms and columns to millimetre precision." },
  { icon: ShieldCheck, ar_t: "3 · طبقة QA بصفر أخطاء", en_t: "3 · Zero-error QA layer", ar_b: "أكثر من 70 فحصاً هندسياً وإنشائياً؛ عند الفشل يُعاد التوليد تلقائياً.", en_b: "70+ geometric & structural checks; auto-regenerates on failure." },
  { icon: Layers, ar_t: "4 · المخرجات المتعددة", en_t: "4 · Cross-disciplinary output", ar_b: "مساقط وواجهات وقطاعات وأساسات وجداول وMEP متزامنة بدون تعارضات.", en_b: "Plans, elevations, sections, foundations, schedules and MEP, synced with no clashes." },
  { icon: RefreshCw, ar_t: "5 · التصدير الصناعي", en_t: "5 · Industry export", ar_b: "DXF لـ AutoCAD، IFC لـ Revit، PDF مختوم، وBOQ بصيغة Excel.", en_b: "DXF for AutoCAD, IFC for Revit, stamped PDF, and Excel BOQ." },
];

export default function Methodology() {
  const { lang } = useAuth();
  const isAr = lang === "ar";
  useEffect(() => {
    document.title = isAr
      ? "كيف يعمل أوتوبيم لوجيك - منهجية توليد المخططات المعمارية والإنشائية"
      : "How AutoBIM Logic Works - Architectural & Structural Plan Methodology";
    const md = document.querySelector('meta[name="description"]');
    if (md) md.setAttribute("content", isAr
      ? "منهجية أوتوبيم لوجيك: محرّك قواعد هندسية حتمي، طبقة QA بأكثر من 70 فحصاً، ومخرجات BIM كاملة مع تصدير DXF وIFC وPDF."
      : "AutoBIM Logic methodology: a deterministic rules-based engine, a 70+ check zero-error QA layer, and full BIM deliverables with DXF, IFC and PDF export.");
  }, [isAr]);
  return (
    <div className="mx-auto max-w-4xl px-4 py-6">
      <PageHeader eyebrow={isAr ? "المنهجية" : "Methodology"} title={isAr ? "كيف يعمل AutoBIM Logic" : "How AutoBIM Logic works"} subtitle={isAr ? "منطق هندسي حتمي - كل مخطط قابل للتفسير وقابل للتدقيق." : "Deterministic engineering logic - every plan is explainable and auditable."} />
      <div className="space-y-3">
        {STEPS.map((s, i) => (
          <Card key={i} className="flex items-start gap-4">
            <div className="grid h-11 w-11 shrink-0 place-items-center rounded-xl bg-primary/15"><s.icon className="text-primary" size={20} /></div>
            <div>
              <div className="font-black">{isAr ? s.ar_t : s.en_t}</div>
              <p className="mt-1 text-sm text-muted-foreground">{isAr ? s.ar_b : s.en_b}</p>
            </div>
          </Card>
        ))}
      </div>
    </div>
  );
}
